// extracted by mini-css-extract-plugin
module.exports = {"title":"HeaderText_title__ftqLf","subtitle":"HeaderText_subtitle__PbXoM"};